import { apiClient, type ApiClientResponse, routes } from 'common/services';

// TODO Type and should not be this feature
export const getProgramUsers = async (id: string) =>
  apiClient.get<any, ApiClientResponse<any>>(routes.program.users(id));
